import React, { useState } from "react";
import SureModal from "../SureModal";
import { useThemeMode } from "../../Themes/ThemeContextTemp.js";

const Modal = ({ isOpen, onClose, title, action, actionType }) => {
  const [sureModalOpen, setSureModalOpen] = useState(false);
  const { COLORS } = useThemeMode();

  const openSureModal = () => {
    onClose();
    setSureModalOpen(true);
  };

  const handleConfirm = () => {
    action();
    setSureModalOpen(false);
    onClose();
  };

  // Safely determine if we are deactivating (if actionType is "Active", it means the item is currently active, so the button action is to Deactivate it!)
  const isDeactivating = actionType === "Active" || actionType?.toLowerCase() === "deactivate";
  const verbText = isDeactivating ? "Deactivate" : "Activate";

  return (
    <>
      <div
        className={`modal fade ${isOpen ? "show" : ""}`}
        tabIndex="-1"
        style={{
          display: isOpen ? "block" : "none",
        }}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content" style={{ background: COLORS.primary }}>
            <div className="modal-header border-0">
              <h5 className="modal-title fw-bold" style={{ color: COLORS.text }}>
                Confirm {verbText}
              </h5>
              <button
                type="button"
                className="btn-close"
                onClick={onClose}
              ></button>
            </div>
            <div className="modal-body">
              <span className="fw-normal" style={{ color: COLORS.text }}>
                Are you sure you want to <b>{verbText.toLowerCase()}</b> this item? <br />
                <div style={{ marginBottom: "10px" }}></div>
                {isDeactivating
                  ? "Deactivating this item will make it unavailable for use in the application until it is reactivated."
                  : "Activating this item will make it available for use in the application wherever applicable."}
              </span>
            </div>
            <div className="modal-footer d-flex flex-column justify-content-center border-0">
              <button
                type="button"
                className="btn rounded-2 fw-medium w-50"
                style={{ background: COLORS.button, color: COLORS.background }}
                onClick={openSureModal}
              >
                Confirm {verbText}
              </button>
              <button
                type="button"
                className="btn rounded-2 fw-medium w-50"
                onClick={onClose}
                style={{ background: COLORS.background, color: COLORS.button }}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
      <SureModal
        isOpen={sureModalOpen}
        onClose={() => setSureModalOpen(false)}
        onConfirm={handleConfirm}
        title={title}
        actionType={actionType} 
      />
    </>
  );
};

export default Modal;